export default {
  button: {
    addDistributors: 'Agregar distribuidores',
    addMore: 'Agregar más',
    addMoreProduct: 'Agregar más productos',
    addMoreProductForGiving: 'Agregar  otro producto para regalar.',
    addMoreProductForOrder: 'Agregar más productos al pedido.',
    addMoreTime: 'Agregar más tiempo',
    addNewGroup: 'Agregar nuevo grupo',
    addProduct: 'Agregar producto',
    addSalesOrder: 'Agregar pedido de venta',
    addStoreToGroup: 'Agregar tienda al grupo',
    addStores: 'Agregar tiendas',
    addToStoreGroup: 'Agregar al Grupo de Tienda',
    agree: 'Aceptar',
    alreadyInOperation: 'Ya en funcionamiento',
    assign: 'Asignar',
    btnCode: 'Ver el código QR de invitación a la tienda',
    cancel: 'Anular',
    clear: 'Borrar  ',
    clearSelected: 'Borrar la selección',
    close: 'Cerrar',
    confirm: 'Confirmar',
    continueEditing: 'Continuar editando',
    copyLink: 'Copiar enlace',
    create: 'Crear',
    createANewReOrder: 'Crear un nuevo pedido',
    createNewDistributorMapping: 'Crear un nuevo mapa del distribuidor',
    createNewStoreVisit: 'Crear una nueva visita a la tienda',
    delete: 'Borrar',
    detail: 'Detalle',
    distributorDetial: 'Detalles del distribuidor',
    edit: 'Modificar',
    eventApplication: 'Solicitud para participar en el evento',
    eventExecution: 'Ejecución del evento',
    exchange: 'Cambio',
    gotIt: 'Entendido',
    ignore: 'Ignorar',
    invitationInfo: 'Información de invitación',
    inviteStoresToParticipate: 'Invitar a las tiendas a participar',
    launch: 'Lanzamiento',
    login: 'Acceso',
    manage: 'Gestionar',
    navigate: 'Navegar',
    nextStep: 'Paso siguente',
    previous: 'Anterior',
    reject: 'Rechazar',
    remove: 'Eliminar',
    reset: 'Reiniciar',
    review: 'Revisión',
    save: 'Guardar',
    search: 'Buscar',
    select: 'Seleccionar',
    selected: 'Seleccionado',
    sellOut: 'Agotado ',
    stillCancel: 'Borrar aún ',
    storeDetial: 'Detalles de la tienda',
    storeInfo: 'Informaciones de la tienda',
    storeTagDetermination: 'Determinación de la etiqueta de la tienda',
    submit: 'Enviar',
    submitForReview: 'Enviar para revisión',
    thinkAgain: 'Piénsarlo de nuevo',
    types: 'tipos',
    viewActivatedStores: 'Ver tiendas activas',
    viewRecentReOrder: 'Ver pedidos recientes',
    viewRecentVisitRecords: 'Ver datos de visitas recientes',
    viewStoreMotivationStatus: 'Ver el estado de participación de la tienda',
    visitInfo: 'Información de la visita'
  },
  form: {
    achievementRate: 'Indice de logro',
    actualTraffic: 'Flujo real (período del evento)',
    addToSchedule: 'Agregar al programa',
    address: 'Dirección',
    afterSalesQuantityPcs: 'Cantidad de Posventa (unidades)',
    afterSalesService: 'Servicio de Posventa',
    afterTheEvent: 'Después del evento',
    assignedBaBd: 'Asignado a BA/BD',
    averageOfDisposableCustomerTraffic: 'Flujo promedio de clientes de productos desechables',
    averageOfOpenSystemCustomerTraffic: 'Flujo promedio de clientes de productos de Sistema Abierto',
    averageOfTraffic: 'Flujo promedio',
    averagePassengerFlow: 'Flujo medio de Visitantes',
    averageSalesPcsDay: 'Promedio de las ventas  (unidades/día)',
    bannerFloorStandProductModelNotes: 'Exposición de Banner / Soporte (Notas)',
    basicInfo: 'Información básica',
    beforeTheEvent: 'Antes del evento',
    brandBannerDisplayed: 'Exhibición del Banner de la Marca',
    brandBannerProductModelNotes: 'Modelo del banner del producto (Notas)',
    brandBuyers: 'Compradores de la Marca',
    brandDay: 'Día de la Marca',
    brandSupplierDistributor: 'Proveedor de la Marca (Distribuidor)',
    business: 'Negocio',
    businessStatus: 'Estado del Negocio',
    businessType: 'Tipo de negocio',
    chainOrNot: 'Cadena o no',
    checkInPhoto: 'Foto check-in',
    chooseDate: 'Eligir la fecha',
    cityNeighborhoodStreetOrBuilding: 'Ciudad, barrio, calle o edificio',
    competitorPrice: 'Precio de la competencia',
    consumablesRatio: 'Relación de consumibles (relación pod/mod / resistencia/dispositivo)',
    contactPosition: 'Posición del contacto',
    corePromotedProductBrand: 'Producto principal de la marca en promoción',
    country: 'País',
    createANewStoreMapping: 'Crear un mapa de la nueva tienda',
    currentProductListingStatus: 'Estado actual del producto listado',
    customerReach: 'Alcance del cliente',
    dayOfPromotion: 'Día de la promoción',
    daysInAdvance: 'Días de antelación',
    decisionMakerInfo: 'Informaciones sobre quién toma las decisiones',
    decisionMakerName: 'Nombre del gerente',
    decisionMakerRole: 'Función del gerente',
    directOrNot: 'Directo o no',
    directSellIn: 'Venta directa (Sell-in)',
    displayMerchandising: 'Exhibición y Merchandising',
    displayPhoto: 'Mostrar la foto',
    disposable: 'Desechable',
    disposableBrandDiversity: 'Diversidad de marcas de productos Desechables',
    disposableCustomerTraffic: 'Flujo de clientes desechables',
    disposableSales: 'Ventas de productos desechables',
    distributorID: 'ID del Distribuidor',
    distributorName: 'Nombre del distribuidor',
    distributorNamePostCodeAddressCityVisitBa: 'Nombre del distribuidor / Código postal / Dirección / Ciudad / BA que visita',
    distributorTag: 'Etiqueta del distribuidor',
    distributorType: 'Tipo de distribuidor',
    eXWEstimatedPrice: 'Precio EXW estimado ($)',
    editReason: 'Motivo de la modificación',
    email: 'E-mail',
    endOfSales: 'Fin de las ventas',
    endTime: 'Fin del tiempo',
    estimatedPriceOfConsumablesEXW: 'Precio EXW estimado de los consumibles ($)',
    eventActualSales: 'Ventas reales del evento (unidades)',
    eventFeedback: 'Comentarios sobre el evento',
    eventPhotos: 'Fotos del evento',
    eventSellInStoreTarget: 'Objetivo de ventas de la tienda para el evento',
    eventStoreContactName: 'Nombre del contacto de la tienda para el evento',
    eventTime: 'Hora del evento',
    eventType: 'Tipo de evento',
    expectedTime: 'Tiempo previsto',
    facebookInstagramAvailable: 'Disponible en Facebook / Instagram',
    firistOrder: 'Primer Pedido',
    firstTimeOrNot: 'Primera vez o no',
    footTrafficInformation: 'Información sobre el flujo de personas',
    image: 'Imagen',
    inv: 'Inv',
    invalid: 'Inválido',
    inventory: 'Inventario',
    invitationsInfo: 'Información sobre las invitaciones',
    isItRecommendedForRoutineOperation: '¿Se recomienda su uso rutinario?',
    isThereAnInvitationForAnEvent: '¿Hay alguna invitación para un evento?',
    kOSGroupInvitation: 'Invitación del Grupo KOS',
    kOSGroupJoinScreenshot: 'Captura de pantalla de la unión al grupo KOS',
    keyDistributor: 'Distribuidor clave',
    lastest: 'Últimas noticias',
    listed: 'Referencia',
    listing: 'En proceso de ser introducido',
    listingOrNot: 'Introdotto o no',
    listingProductSupplierDistributor: 'Proveedor de los productos mencionados (Distribuidor)',
    listingStatus: 'Estado de la lista',
    lssueDeviceMode: 'Problema con el modo de funcionamiento del dispositivo',
    lssusDescription: 'Descripción del problema',
    mDWholesalePrice: 'Precio de distribución de los MD ($)',
    marketFeedback: 'Comentarios del mercado',
    marketInformationCollection: 'Recopilación de las informaciones del mercado',
    materialDelivery: 'Entrega de material',
    materialSampleDelivery: 'Entrega de Materiales y Muestras',
    materialSamplePhoto: 'Fotos de materiales y muestras',
    month: 'Mes',
    monthlyAverageSalesForKit: 'Ventas mensuales promedio del kit (unidades)',
    name: 'Nombre',
    namePostCodeAddressCity: 'Nombre / Código postal / Dirección / Ciudad',
    newBuyers: 'Nuevos compradores',
    newBuyersReOrderStoreCount: 'Nuevos compradores y número de pedidos repetidos',
    newGroup: 'Nuevo Grupo',
    notKeyDistributor: 'No es un distribuidor clave',
    notListing: 'No en la lista',
    notes: 'Notas',
    numberOfAffiliatedCoreStore: 'Número de tiendas principales afiliadas',
    numberofChainStores: 'Número de tiendas de cadena',
    officialWebsiteAvailable: 'Página web oficial disponible',
    openSystem: 'Sistema Abierto',
    openSystemCustomerTraffic: 'Flujo de clientes para Sistemas Abiertos',
    openSystemSales: 'Ventas de Sistemas Abiertos',
    orderGiftVolume: 'Volumen del pedido gratuito',
    orderModificationHistory: 'Historial de la modificación del pedido',
    orderSalesVolume: 'Volumen de los pedidos de venta',
    orders: 'Pedidos',
    other: 'Otro',
    otherCategory: 'Otras Categorías',
    otherCosts: 'Otros costos (materiales, etc.)',
    otherDistributor: 'Otro distribuidor',
    outsidePicture: 'Imagen exterior',
    overallSalesPerformance: 'Resultados general de las ventas',
    pO: 'PO',
    pOOrder: 'Pedido PO',
    paid: 'Pagado',
    passengerFlowStatistics: 'Estadísticas del flujo de los clientes (periodo del evento)',
    password: 'Contraseña',
    paymentStatus: 'Estado del pago',
    paymentType: 'Tipo de pago',
    pcs: 'Piezas',
    percentageOfDisposable: 'Porcentaje de desechables',
    percentageOfOpenSystem: 'Porcentaje de Sistemas Abiertos',
    permanentlyClosed: 'Cerrado permanentemente',
    phone: 'Teléfono',
    phoneNumber: 'Número de teléfono',
    photo: 'Foto ',
    planName: 'Nombre del plan',
    plannedVisitDate: 'Fecha prevista de la visita',
    pleaseSelect: 'Selecionar por favor',
    poPhoto: 'Foto PO',
    policy: 'Política',
    popUp: 'Pop Up',
    popupDisplayPics: 'Imágenes Pop Up',
    position: 'Posición',
    posterDisplayed: 'Cartel expuesto',
    preEventWarmUpCooperation: 'Cooperación en la preparación del evento',
    productCashCheque: 'Producto + Efectivo / Cheque',
    productDailySales: 'Ventas diarias del producto',
    productInfo: 'Información del producto',
    productListingStatus: 'Estado de introducción del producto',
    productSalesInventory: 'Ventas e inventario de los productos',
    promotionCapability: 'Capacidad de promoción',
    promotionCapabillty: 'Capacidad promocional',
    promotionEffect: 'Efecto de la Promoción',
    quantityGivenAwayPcs: 'Cantidades distribuidas (unidades)',
    quantitySoldPcs: 'Cantidades vendidas (unidades)',
    receipt: 'Recibo',
    recommendationsEventInvitations: 'Recomendaciones e invitaciones a eventos',
    recommendedForRoutineOperation: 'Recomendado para uso rutinario',
    reorderBuyers: 'Compradores con pedidos repetidos',
    retailPrice: 'Precio de venta al público',
    retailPriceMoney: 'Precio de venta al público ($)',
    retailerPurchasePrice: 'Precio de compra de la tienda',
    rollUpBannerOrFloorStandDisplay: 'Roll-Up o Expositor de suelo',
    ruleTipsOne: 'Selecionar una tienda por favor.',
    salesBeforePromotion: 'Ventas antes de la promoción (unidades / día)',
    salesPcs: 'Ventas (unidades)',
    salesPcsWeek: 'Ventas (unidades/semana)',
    salesPerformance: 'Resultados de las ventas',
    salesPerformancePcs: 'Resultados de las ventas (unidades)',
    salesReorderForecast: 'Previsiones de ventas y pedidos repetidos',
    salesTargetForThisEventPcs: 'Objetivo de ventas para este evento (unidades)',
    sample: 'Muestra',
    sampleConsumed: 'Muestra consumida',
    sampleDelivery: 'Entrega de la muestra',
    sampleGiveawayPcs: 'Muestras en regalo (unidades)',
    samplePhoto: 'Foto de la Muestra',
    searchBrandOrProduct: 'Buscar la marca o el producto...',
    selectEndTime: 'Seleccionar la hora de finalización',
    selectProductsToUpdateListingStatus: 'Seleccionar los productos para actualizar el estado del listado',
    selectStartTime: 'Selecionar la hora de inicio.',
    selectTimePeriod: 'Seleccionar el período de tiempo',
    sellInByMyselfThisTime: 'Ventas directa por mi parte esta vez',
    sellInFromAcmefog: 'Ventas por ACMEFOG',
    sellInFromDistributor: 'Ventas por el distribuidor',
    sellInPhoto: 'Foto de la venta',
    sellInQuantity: 'Cantidad vendida (unidades)',
    sellOutOrders: 'Pedidos de venta (sell-out)',
    sentOut: 'Enviado',
    servicePhoto: 'Foto de servicio',
    staffName: 'Nombre del personal',
    startTime: 'Hora de inicio',
    storeCapacityVerification: 'Verificación de la capacidad de la tienda',
    storeGroup: 'Grupo de tiendas',
    storeID: 'ID Tienda',
    storeName: 'Nombre de la tienda',
    storeNamePostCodeAddressCityVisitBa: 'Nombre de la tienda / Código postal / Dirección / Ciudad / BA en visita',
    storePurchasePrice: 'Precio de compra de la tienda ($)',
    storeServiceRecords: 'Datos de Servicio de la Tienda',
    storeTag: 'Etiqueta de la tienda',
    storeType: 'Tipo de tienda',
    supportsPreEventInStoreDisplay: 'Soportar la visibilidad del evento en las tiendas antes del evento mismo',
    tax: 'Impuesto',
    taxExclusive: 'Excluyendo los pagos de los impuestos',
    taxInclusive: 'Impuestos incluidos',
    temporarilyClosed: 'Cerrado temporalmente',
    testingStationDisplayed: 'Exhibición de lo stand para las pruebas',
    testingStationProductModelNotes: 'Producto en exhibición (Notas)',
    timePeriods: 'Períodos de tiempo',
    total: 'Totale',
    totalDisposableSales: 'Ventas totales de productos "desechables"',
    totalOpenSystemSales: 'Ventas totales de los Sistemas Abiertos (unidades/semana)',
    totalOpenSystemsSales: 'Ventas totales de los Sistemas Abiertos (unidades/semana)',
    totalProductSales: 'Ventas totales del producto',
    totalSalesInStoreDuringEvent: 'Ventas totales en tienda durante el evento (unidades)',
    totalSalesPcs: 'Ventas totales (unidades)',
    totalSellIn: 'Ventas totales (Sell-in)',
    totalStoreTraffic: 'Flujo total de personas en la tienda',
    totalUsed: 'Total utilizado',
    uSD: 'USD',
    unpaid: 'No pagado',
    userName: 'Nombre del Usuario',
    visitDate: 'Fecha de la visita',
    visitInfo: 'Informaciones de la visita',
    warmUp: 'Preparación',
    warmUpType: 'Tipo de Preparación',
    wayOfList: 'Método de referencia',
    weekdayFootTraffic: 'Flujo de clientes en días laborables',
    weekdayPeakTraffic: 'Flujo máximo en días laborables',
    weekendFootTraffic: 'Flujo de clientes durante el fin de semana',
    weekendPeakTraffic: 'Flujo máximo durante el fin de semana',
    weeklySalesInventoryBrforeEventPcs: 'Ventas e inventario semanales antes del evento (unidades)',
    whatsAppGroupAvailable: 'Grupo de WhatsApp disponible',
    wholesalePurchasePrice: 'Precio de compra en distribución',
    wholesaleRetailerPurchasePrice: 'Precio de compra al por mayor y al por menor (USD)'
  },
  shared: {
    activity: 'Actividad',
    addDistributorsToThePlan: 'Agregar los distribuidores al plan',
    addNewStoreMapping: 'Agregar nuevo mapa de la tienda',
    addNewStoreVisit: 'Agregar nueva visita a la tienda',
    addNewVisitSchedulePlannedVisitDate: 'Agregar un nuevo calendario de la visita, fecha de visita prevista:',
    addRetailStoresToThePlan: 'Agregar tiendas minoristas al plan',
    addToExistingPlan: 'Agregar al plan existente',
    addToVisitPlan: 'Agregar al plan de visita',
    agreeToApplicationForKickOutOfOperation: 'Acuerdo con la solicitud de abandonar la operación.',
    anEventToBeHeld: 'Evento que se tendrá',
    aplyToKickOutOfOperation: 'Salir de la operación',
    applicable: 'Adecuado',
    applicant: 'Solicitante',
    applicationForKickOutOfOperation: 'Solicitud de salir de la operación',
    approvalTime: 'Tiempo de aprobación',
    approved: 'Aprobado',
    approver: 'Responsable',
    auditResult: 'Resultado de la auditoría',
    automaticallyAddCurrentItemAfterCreation: 'Agregar automáticamente el elemento actual después de su creación.',
    bA: 'BA',
    balance: 'Balance',
    bindProduct: 'Producto de referencia',
    brandDayApplication: 'Solicitud para el Día de la Marca',
    buy: 'Comprar',
    by: 'por',
    byDay: 'Por día',
    byTime: 'Por tiempo',
    byVisitBy: 'Visita realizada por',
    cancelAllocationOfStores: 'Aborrar la asignación de las tiendas',
    cancelBrandDay: 'Aborrar el día de la Marca',
    cancelPopUpEvent: 'Aborrar el evento Pop Up',
    cancelVisitSchedule: 'Aborrar el plan de las visitas',
    changeDetails: 'Detalles de la modificación',
    closed: 'Cerrado',
    collecting: 'Recopilación',
    completed: 'Completado',
    confirmRedemaption: 'Confirmar el reembolso',
    createNewVisitPlan: 'Crear nuevo plan de visitas',
    createVisitPlan: 'Crear un plan de visita',
    creditBreakdown: 'Distribución del crédito',
    creditEarned: 'Crédito obtenido',
    creditTransactionHistory: 'Historial de las transacciones',
    current: 'Actual',
    daily: 'A diario',
    dateOfInvitation: 'Fecha de invitación',
    day: 'Día',
    daysAgo: 'hace días',
    deadline: 'Fecha límite',
    development: 'Desarrollo',
    distributor: 'Distribuidor',
    distributors: 'Distribuidores',
    distroInfo: 'Información de la distribución',
    dynamics: 'Dinámica',
    earnedPoints: 'Puntos ganados {totalIntegral}',
    end: 'Fin',
    event: 'Evento',
    eventExecute: 'Ejecución del evento',
    eventInvitations: 'Invitaciones a eventos',
    eventInvite: 'Invitación al evento',
    eventPolicy: 'Política del evento',
    expectTime: 'Tiempo de espera',
    feedback: 'Comentario',
    filter: {
      accountManagement: 'Gestión de cuentas',
      activated: 'Activado',
      all: 'Todo',
      allType: 'Todo tipo',
      average: 'Promedio',
      brand: 'Marca',
      brandFilter: 'Filtro de la Marca',
      confirm: 'Confirmar',
      containAll: 'Contener (todo)',
      containAny: 'Contener (Algunos)',
      customize: 'Personalizar',
      distanceEarliest: 'Mapa de la tienda: más reciente ',
      distanceFarthest: 'Distancia: más lejos',
      distanceLatest: 'Mapa de la tienda: Últimas noticias',
      distanceNearest: 'Distancia: la más cercana',
      effective: 'Eficaz',
      endDate: 'Fecha de finalización',
      filter: 'Filtro  ',
      good: 'Bien',
      goodTop: 'Bueno: marcas de nivel superior y medio',
      high: 'Alto',
      inMonth: 'en un mes',
      inTwoWeeks: 'en dos semanas',
      inWeek: 'En una semana',
      incentiveHistory: 'Historia de los incentivos',
      kA: 'KA',
      lessThanDays: 'Menos de 7 días',
      low: 'Bajo',
      mD: 'Distribuidor principal',
      me: 'Me ',
      needTo: 'Necesito de',
      no: 'No',
      noFilter: 'Sin Filtro',
      notActivated: 'No activado',
      notContainAny: 'No contiener (Algunos)',
      notEqualTo: 'No igual a (Todos)',
      notNeedTo: 'No necesito de',
      notParticipated: 'No ha participado',
      notSet: 'No configurado',
      operationBottonmost: 'Operación: Baja',
      operationTopmost: 'Operación: Máxima',
      participated: 'Participado',
      poor: 'Pobre',
      poorMainly: 'Pobre: Principalmente Marcas de primera línea',
      potential: 'Potencial',
      procMgr: 'Gerente de procesos',
      product: 'Producto',
      reset: 'Reiniciar',
      rich: 'Rico',
      richTop: 'Rico: marcas superiores, de nivel medio y bajo',
      russia: 'Rusia',
      sDMultiItemDistro: 'SD (Distribuidor de múltiples artículos)',
      sDSmokeDistro: 'SD (Distribución de artículos sobre tabaquismo)',
      sVIPCore: 'SVIP Core',
      salesclerk: 'Representante de ventas',
      selectDate: 'Seleccionar la fecha',
      selectEndDate: 'Seleccionar la fecha de finalización',
      selectStartDate: 'Seleccionar la fecha de inicio',
      shopkeeper: 'Tendero',
      sort: 'Tipo',
      startDate: 'Fecha de inicio',
      time: 'Duración',
      timeDays: '7~15 días',
      timeFilter: 'Filtro por fecha',
      toBeVerified: 'Pendiente de verificación',
      type: 'Tipo',
      typeFilter: 'Filtro por tipo',
      unitedKingdom: 'Reino Unido',
      unitedStates: 'Estados Unidos',
      unknown: 'Desconocido',
      vIPCore: 'VIP Core',
      viewStore: 'Ver la tienda',
      yes: 'Si '
    },
    from: 'Desde',
    get: 'Obtener',
    giveUpReason: 'Razones para la renuncia',
    hideUpdate: 'Ocultar "actualización"',
    insufficientPoints: 'Puntos insuficientes',
    inventoryPcs: 'Inventario (unidades)',
    inviteFansToJoinTheCommunity: 'Invitar a los fans a unirse a la comunidad',
    kickOut: 'Expulsar',
    kickOutOfOperation: 'Expulsión de la operación',
    kilometer: 'km',
    launchPopUpEvent: 'Evento de lanzamiento',
    listingProduct: 'Listado de productos',
    loading: 'Cargando…',
    locationName: 'Nombre del lugar',
    mapping: 'Cartografía',
    markToIgnoreThisTransferAllocation: 'Marcar para ignorar esta transferencia y asignación.',
    materialSample: 'Material/Muestra',
    materialSampleDeliveryDataMaintenance: 'Mantenimiento de datos de entrega de materiales y muestras',
    metre: 'm',
    modifiedProductQuantity: 'Cantidad del producto modificada',
    modifyBrandDayApplicationInfo: 'Modificar las informaciones del día de la Marca',
    modifyPersonalInformation: 'Modificar las informaciones personales',
    modifyReOrder: 'Cambiar el pedido',
    modifyStoreTag: 'Modificar la etiqueta de la tienda',
    more: 'Más',
    multiStopRoute: 'Ruta con múltiples paradas',
    myApproval: 'Mi aprobación',
    nearbyStores: 'Tiendas cercanas',
    need: 'Necesitades',
    newDistributorMapping: 'Nuevo mapeo del distribuidor',
    newDistributorVisit: 'Visita del nuevo distribuidor',
    newReOrder: 'Nuevo pedido',
    newVisitSellIn: 'Nueva visita y venta',
    nonEditable: 'No editable',
    none: 'Ninguno',
    notChangedYet: 'Aún no ha cambiado',
    notStarted: 'No comenzado',
    offSite: 'Sitio externo',
    onSite: 'En el sitio',
    operation: 'Operación',
    overdueFollowUp: 'Seguimiento pendiente',
    pendingReview: 'Pendiente de revisión',
    plannedVisitDate: 'Fecha prevista de la visita',
    point: 'Punto',
    pointsRank: 'Clasificación por puntos',
    preEvent: 'Pre-evento',
    productBindingRecords: 'Datos relacionados con el producto',
    productDetails: 'Detalles del producto',
    proofOfDelivery: 'Comprobante de entrega',
    psi: 'PSI',
    quanntityGivenAway: 'Cantidad regalada',
    quanntitySold: 'Cantidad vendida',
    reason: 'Motivo',
    records: 'Datos  ',
    redeemIncentiveRewardsForEmployees: 'Rescatar los incentivos para los empleados',
    redeemedCredit: 'Crédito recuperado',
    rejectApplicationForKickingOutUpStore: 'Rechazar la solicitud de expulsión de la tienda.',
    rejected: 'Rechazado',
    relevantVisitPlans: 'Planes de visita relevantes',
    removedDistributor: 'Distribuidor excluido',
    removedProducts: 'Productos eliminados',
    reorder: 'Pedir de nuevo',
    reorderPcs: 'Pedir de nuevo (piezas)',
    report: 'Informe',
    reportPopUpEventExecutionStatus: 'Estado de ejecución del informe del evento',
    reportingOnTheBrandDayExecution: 'Informe de ejecución del Día de la Marca',
    reviewStatus: 'Estado de la revisión',
    rules: 'Normas',
    sN: 'Número de serie',
    salesPcsWeek: 'Ventas (unidades/semana)',
    schedule: 'Cronograma',
    selectDistributor: 'Seleccionar el Distribuidor',
    selectFromExistingPlan: 'Seleccionar uno de los 4 planes existentes.',
    selectGiftToRedeem: 'Seleccionar un regalo para rescatarlo',
    selectStore: 'Seleccionar tienda',
    selectType: 'Seleccionar el tipo',
    sellOutDataMaintenance: 'Mantenimiento de datos de venta total',
    sellOutProduct: 'Producto agotado',
    setAssignedBABDInTheManagementSystem: 'Configurar el BA/BD en el sistema de gestión',
    setStoreLabels: 'Establecer las etiquetas de la tienda',
    setStoreTag: 'Establecer la etiqueta de la tienda',
    setTheResponsiblePerson: 'Encontrar la persona responsible',
    startingNow: 'Comenzando ahora',
    store: 'Tienda ',
    storeActivity: 'Actividad de la tienda',
    storeAllocationTime: 'Tiempo de asignación de la tienda',
    storeID: 'ID Tienda',
    storeIncentive: 'Incentivo a la tienda',
    storeIncentiveBindProduct: 'Incentivo a la tienda: Conectar el producto',
    storeIncentiveDeactivateEmployeeAccount: 'Incentivo a la tienda: Desactivar la cuenta del empleado',
    storeIncentiveInviteEmployeeToActivate: 'Incentivo a la tienda: invitar al empleado a la activación',
    storeIncentiveUploadSalesProof: 'Incentivo para la tienda: Subir comprobante de ventas',
    storeOperation: 'Operación de la tienda',
    storeParticipant: 'Participante en la tienda',
    storeTagChange: 'Cambiar la etiqueta de la tienda',
    storeToDoItems: 'Cosas "TO DO" de la tienda',
    stores: 'Tiendas  ',
    storesAreTransferredAndAllocatedTo: 'Las tiendas se transfieren y se asignan a',
    storesLevel: 'Nivel de las tiendas',
    submissionTime: 'Hora de envío',
    success: 'éxito',
    summary: 'Resumen',
    theFirstSaleOrInvitation: 'La primera venta o invitación',
    timeOfApplication: 'Fecha de la solicitud',
    title: {
      activatedStores: 'Tiendas Activadas',
      anEventStoreToBeHeld: 'Un evento de la tienda para organizar',
      basicInfo: 'Información básica',
      createANewGroup: 'Crear un nuevo grupo',
      createdSuccessfully: 'Creado con éxito',
      days: 'Días',
      distributorInfo: 'Información del distribuidor',
      distributorMapping: 'Mapeo del distribuidor',
      distributorOperation: 'Operación del distribuidor',
      editGroupName: 'Cambiar el nombre del grupo',
      estimationOfResults: 'Estimación de los resultados',
      eventHeld: '¿Se ha celebrado un evento?',
      eventRecord: 'Dato del evento',
      filterDepartment: 'Filtrar por departamento',
      filterPerson: 'Filtrar por persona',
      illDesc: 'Descripción de la imagen',
      incentive: 'Incentivo',
      listState: 'Estado de la lista',
      manageMyGroups: 'Gestionar mis grupos',
      mappingSucceed: 'Mapeo exitoso',
      marketInsight: 'Análisis de mercado',
      mySchedule: 'Mi programa',
      orderDetail: 'Detalles del pedido',
      orderUpdateRecord: 'Historial de las revisiones del pedido',
      others: 'Otros',
      overdueStoreFailureToFollowUp: 'Retraso en el seguimiento por parte de la tienda',
      oversightMatters: 'Cuestiones a revisar',
      participationRecord: 'Registro de las participaciones',
      pleaseSelectYourWorkItems: 'Seleccionar tus herramientas de trabajo',
      pointsRedemption: 'Rescate de los puntos',
      preparations: 'Preparativos',
      productListed: 'Listado de los productos',
      prompt: 'Prompt',
      quickEntrance: 'Entrada rápida',
      reOrderOrNot: 'Nuevo surtido o no',
      reOrderSellIn: 'Nuevo Pedido (Sell-in)',
      retailOperationSystem: 'Sistema de operaciones minoristas',
      ros: 'ROS',
      selectAPolicy: 'Seleccionar una política',
      selectGroup: 'Seleccionar el grupo',
      selectItemOfWork: 'Seleccionar el elemento de trabajo',
      selectPlan: 'Seleccionar el plan',
      selectRegion: 'Seleccionar la Comunidad',
      selectYearAndMonth: 'Seleccionar el año y el mes.',
      state: 'Estado',
      storeAssignment: 'Asignación de la tienda',
      storeDevelopment: 'Desarrollo de la tienda',
      storeInfo: 'Información de la tienda',
      storeMapping: 'Mapeo de la tienda',
      storeTag: 'Etiqueta de la tienda',
      storeVisit: 'Visita a la tienda',
      storesToBeAllocated: 'Asignación de las tiendas',
      theNumberOfProductsSold: 'El número de productos vendidos',
      timeSinceLastVisit: 'Tiempo transcurrido desde la última visita',
      transferAllocationRecords: 'Registros de transferencia y asignación',
      transferAndAllocate: 'Transferir y asignar',
      visitByBa: 'Visita del BA',
      visitOrNot: 'Visitar o no',
      whichDay: 'Qué día',
      minDays: 'Días mín.',
      maxDays: 'Días máx.'
    },
    titleEight: 'Ningún evento está permitido que dure más de {días} días.',
    titleEighteen: '¿Confirmar la revocación de este participante?',
    titleEleven: 'Paso 1 Información básica sobre el evento actual',
    titleFifteen: 'Paso 3 Lista de productos actual y datos de ventas',
    titleFive: 'Un nuevo pedido de la tienda recientemente se actualizó. ¿Aún quieres añadir algo?',
    titleFour: 'Recientemente actualizaste la información de tu visita a esta tienda. ¿Deseas continuar editando?',
    titleFourteen: 'Revisar si hay actualizaciones. La información más reciente se actualizará automáticamente a la información básica una vez que se haya enviado la solicitud del evento.',
    titleNine: 'La información del evento debe enviarse dentro del plazo establecido. Cada evento debe registrarse solo una vez.',
    titleNineteen: 'Enviar el contenido de la notificación indicada anteriormente a la persona a través de SMS.',
    titleOne: 'Filtrar los datos según la siguiente condición',
    titleSeven: 'El siguiente resumen de la actividad se genera automáticamente en función de los datos introducidos.',
    titleSeventeen: 'Invitar a tus fans a unirse a la comunidad y ganar {totalIntegral} puntos',
    titleSix: 'La información sobre esta tienda se actualizó recientemente. ¿Aún deseas crear una nueva visita?',
    titleSixteen: 'Paso 4: Estado de preparación del evento.',
    titleTen: 'El estado del evento debe enviarse diariamente. Se generará automáticamente un resumen del evento una vez finalizado.',
    titleThirteen: 'La siguiente información se mostrará automáticamente si ya se ha rellenado previamente.',
    titleThirty: 'Una vez que la transferencia se haya realizado con éxito y ya no sea recuperable, asegúrese de que la tienda haya vuelto a colocar el producto en los estantes.',
    titleThirtyOne: 'El plan de visita se ha creado correctamente y se pueden añadir tiendas/distribuidores a la ruta de la visita planificada.',
    titleThirtyThree: '¿Es necesario actualizar el estado del listados de los productos en esta ocasión?',
    titleThirtyTwo: 'Agregar {keyVal} a otros planes de visita',
    titleThree: 'Recientemente has actualizado el nuevo pedido de la tienda. ¿Piensas seguir editándolo?',
    titleTwelve: 'Paso 2 {type} Información básica',
    titleTwenty: 'Invitar al personal a informarse sobre los requisitos para recibir el bonus.',
    titleTwentyEight: 'El nivel de la tienda no se ha determinado desde que cesó sus operaciones. Pendiente de envío.',
    titleTwentyFour: 'Describir el motivo por el que ha sido excluido.',
    titleTwentyNine: 'Transferir la tienda a un "equipo de operaciones" y asignar un supervisor.',
    titleTwentyOne: 'Rescate exitoso. Se han deducido {currentIntegral} créditos de la cuenta de este empleado.',
    titleTwentySeven: '{backlogUserName} El evento {sourceName} comenzará a las {backlogTime}, Va a ver.',
    titleTwentySix: 'Hay invitaciones para el evento en la tienda que deben enviarse. Ver la invitación.',
    titleTwentyThree: 'Solicitud de exclusión de la Operación',
    titleTwentyTwo: '¿Está seguro que desea eliminar este producto?',
    titleTwo: 'Última visita de esta persona',
    titleThirtyFour: 'Introduzca el número mínimo de días, el número máximo de días o ambos. Deje un campo en blanco si no se aplica el límite correspondiente.',
    to: 'a',
    toBeAllocated: 'Por asignar',
    today: 'hoy',
    transferAllocation: 'Transferencia y asignación',
    transferAndAssignStoresTo: 'Transferir y asignar tiendas a',
    underReview: 'En revisión',
    updateDistributorMapping: 'Actualizar la asignación de los distribuidores',
    updateDistributorVisit: 'Actualización sobre la visita al distribuidor',
    updatePopUpEvent: 'Actualización del evento',
    updateRecord: 'Actualizar el registro',
    updateStoreInfoBy: 'Actualización de las informaciones por ',
    updateStoreMappingInformation: 'Actualizar la información de mapeo de la tienda',
    updateStoreVisitInformation: 'ctualizar información sobre la visita a la tienda',
    updateVisitSellIn: 'Actualización de la visita y la venta',
    uploadSalesReceipt: 'Subir la factura de la venta',
    visit: 'Visita',
    visitPlan: 'Plan de visita',
    visitSellIn: 'Visita y venta',
    visitTime: 'Horas de visita',
    webSite: 'Página web',
    yesterday: 'ayer'
  },
  tips: {
    accountOrPasswordIncorrect: 'Cuenta o contraseña incorrecta',
    addressCopiedFailed: 'Error al copiar la dirección',
    addressCopiedSuccessfully: 'Dirección copiada correctamente',
    areYouSureToExit: '¿Estás seguro de salir?',
    browserDoesNotSupportCopyFunction: 'El programa de navegación no admite la función de copiar.',
    checkInPhotoIsRequired: 'Se requiere la fotografía para el registro.',
    chooseOnePersonAtLeast: 'Elije al menos a una persona.',
    distributorPrice: 'Precio del distribuidor',
    eventCancelled: 'Evento cancelado',
    filterByGroupName: 'Filtrar por el nombre del grupo',
    isRequired: 'Es requerido',
    locationNotFound: 'Ubicación no encontrada',
    loginSuccess: 'Inicio de sesión correcto',
    messageEight: 'Si esta información ya se ha enviado, los datos históricos se completarán automáticamente. Si hay algún otro cambio, edítelo directamente.',
    messageEleven: 'Incluyendo todos los sistemas abiertos/desechables de otras Marcas.',
    messageFifteen: '¿Confirma la eliminación de este pedido de venta?',
    messageFifty: '¿Debe eliminarse este plan de visita? Si ya se ha creado un plan, se cancelará automáticamente.',
    messageFiftyOne: '¿Deseas eliminar el {targetType} actual de su plan de visita y cancelar la programación asociada?',
    messageFiftyThree: '¿Deseas eliminar este plan de visita? Si ya se ha creado un horario, se cancelará automáticamente.',
    messageFiftyTwo: 'Crear automáticamente calendarios de visitas para las tiendas/distribuidores añadidos a este plan.',
    messageFive: 'La hora de finalización debe ser posterior a la hora de inicio',
    messageForty: 'El sistema actual de mapeo de tiendas está funcionando correctamente y se puede obtener más información sobre las tiendas mediante visitas',
    messageFortyEight: 'Eliminar este grupo (Esta acción solo elimina el grupo, no las tiendas que contiene).',
    messageFortyFive: 'La etiqueta de tienda actual es: {customerTag}. ¿Te gustaría cambiarla?',
    messageFortyFour: 'Tras su eliminación, la tienda no aparecerá en la lista hasta que el BA vuelva a enviarla.',
    messageFortyNine: '¿Confirmar la transferencia de la tienda y asignarla a la persona responsable designada?',
    messageFortyOne: 'Cambiar el estado de la tienda a: {statusVal}, la tienda no se mapeará ni se visitará, ¿está seguro o no?',
    messageFortySeven: 'Si superas la revisión, la autorización de la tienda se liberará y se transferirá al área de "Expansión". Los registros de transacciones anteriores se archivarán automáticamente y no se podrán modificar, así que ten cuidado al realizar este proceso.',
    messageFortySix: 'Se transferirá al equipo de «Desarrollo» con los permisos revocados. Los datos históricos de las operaciones se archivarán y no se podrán editar.',
    messageFortyThree: 'Ninguna venta o lista de venta. Non se recomienda.',
    messageFortyTwo: 'La venta por mi parte es necesaria esta vez',
    messageFour: 'Mantener pulsado para guardar en la galería/álbum de fotos.',
    messageFourteen: '¿Eliminar los materiales seleccionados y sus cantidades?',
    messageNine: 'Al eliminar el producto, se borrará la cantidad introducida. ¿Deseas eliminarlo?',
    messageNineteen: 'Tareas a completar: Cuando se asigna una nueva tienda a un empleado, si la tienda tiene una invitación a un evento registrado, los empleados deben completar la presentación del evento y subir la implementación dentro del plazo especificado.',
    messageOne: 'Puedes crear tus propios grupos de tiendas para categorizarlas. Los grupos de tiendas solo son visibles para la persona que los creó.',
    messageSeven: 'La hora es incorrecta',
    messageSeventeen: 'Pendiente de revisión: Solicitudes deben ser revisadas',
    messageSix: 'Por favor, completar la información completa.',
    messageSixteen: 'Debe ser asignado: Envíar la visita a una tienda al Grupo de Desarrollo de las tiendas. Si al menos un producto se encuentra en los estantes en el registro de la visita, el sistema generará automáticamente un registro de "tienda por asignar" y el gerente de ventas podrá transferir y asignar la tienda a la persona designada, quien será responsable del seguimiento y la gestión.',
    messageTen: 'Introducir los datos de ventas previo al evento solo el día 1',
    messageThirteen: 'Una vez cancelado el evento, no será posible completar el informe del evento. ¿Confirmar la cancelación?',
    messageThirty: 'Rechazar la solicitud de {createUserName} para excluir la tienda, confirmar o no.',
    messageThirtyEight: 'Según el funcionamiento diario de la tienda, configurar la etiqueta de la tienda en',
    messageThirtyFive: 'introducir las palabras clave para buscar tiendas.',
    messageThirtyFour: 'Ingresar el distribuidor de {projectName}',
    messageThirtyNine: 'Según el evento, la etiqueta de la tienda está establecida en',
    messageThirtyOne: 'La fecha de finalización no puede ser anterior a la fecha de inicio.',
    messageThirtySeven: '¿Eliminar las muestras seleccionadas y las cantidades introducidas?',
    messageThirtySix: 'Introducir las palabras clave para buscar el distribuidor',
    messageThirtyThree: 'Seleccionar la fecha de la visita',
    messageThirtyTwo: 'El mapeo de los distribuidores actualmente en uso es exitoso y se puede recopilar informaciones adicionales gracias a las visitas.',
    messageThree: 'Invitar al personal a inaugurar el concurso para la entrega de los premios',
    messageTwelve: 'La solicitud del evento se ha enviado correctamente y el evento se ha añadido automáticamente a tu agenda diaria.',
    messageTwentyEight: 'Por favor, completar las informaciones',
    messageTwentyFive: 'seleccionar una posición',
    messageTwentyFour: 'Introducir tu nombre',
    messageTwentyOne: 'Mantener pulsado el código QR para guardarlo en el álbum.',
    messageTwentySeven: 'Habilitar el permiso para el evento y envía un SMS al teléfono móvil de la persona',
    messageTwentySix: 'introducir tu número de teléfono móvil completo.',
    messageTwentyThree: 'Para garantizar la correcta entrega del enlace, confirmar que el número de teléfono introducido es correcto.',
    messageTwentyTwo: 'Imposible obtener la imagen del código QR',
    messageTwo: 'Eliminar la tienda del grupo (la tienda no se eliminará).',
    messgaeEighteen: 'Seguimiento pendiente: De acuerdo con los indicadores de la operación comercial, se establece una frecuencia correspondiente para el seguimiento de las tiendas principales/de prueba, y si el seguimiento excede el intervalo preestablecido, se emitirá una alerta temprana.',
    messgaeTwenty: 'Únete a la iniciativa escaneando el código QR o haciendo clic en el enlace.',
    networkError: 'Error de red',
    noAvailablePolicies: 'ninguna política disponible',
    noData: 'No datos',
    noMore: 'No más',
    noMoreData: 'No más datos',
    noMoreProducts: 'No más productos',
    noMoreStores: 'No más tiendas',
    noMoreThan: 'No más de 5',
    noPermissionYet: 'Aún ningun permiso',
    nothingMore: '¡No hay nada más que añadir!',
    noticeCopiedFailed: 'Fallo en la copia de los datos',
    noticeCopiedSuccessfully: 'Aviso copiado correctamente',
    passwordIsRequired: 'Se requiere la contraseña',
    pending: 'Pendiente',
    planningTheRoute: 'Planificar la ruta',
    pleaseChooseWhichDayToSell: 'Por favor, elijir el día en el que se desea realizar la venta',
    pleaseEnterAnInteger: 'introducir un número entero',
    pleaseEnterGroupName: 'Introducir el nombre del grupo',
    pleaseFillInTheSales: 'Completar el formulario de ventas',
    pleaseInputTheSales: 'Introducir los datos de ventas',
    pleaseSelectAGroup: 'Seleccionar un grupo',
    pleaseSelectProduct: 'Seleccionar un producto',
    pleaseSelectThePlan: 'Seleccionar el plan',
    productIsRequired: 'El producto es obligatorio',
    reasonIsRequired: 'Es necesario especificar el motivo',
    required: 'Obligatorio',
    sellInFromAcmefogInIsRequired: 'Se requiere las ventas por Acmefog',
    stayTuned: 'Manténgante al tanto',
    storeTagIsRequired: 'Se requiere la etiqueta de la tienda',
    successSave: 'guardado con éxito',
    uploadFailed: 'Error al cargar',
    usernameIsRequired: 'Se requiere el nombre del usuario'
  }
}
